import Rodape from '../assets/styles/FooterStyle';

const Footer = () => {
  return (
    <Rodape>
      <p>Desenvolvido por Natã Araújo</p>
    </Rodape>
  );
};

export default Footer;
